export const _LOAD_MODEL_ = 'Load:Service';
export const _SAVE_SERVICE_SUCCESS_ = 'Save:ServiceSuccess';

export const MODEL = {
  id: null,
  name: null,
  price: null,
};
